import React from "react"
import Layout from "../components/layout"
import { injectIntl } from "gatsby-plugin-intl"
import Banner from "../includes/driver/banner"
import WhyFant from "../includes/driver/whyfant"
import Team from "../includes/driver/team"
import Actions from "../includes/driver/actions"
import Requirement from "../includes/driver/requirement"
import Faq from "../includes/driver/faq"
import { defaultIntl } from "../utils"
import Phone from "../includes/driver/phone"

const DriverPage = ({ intl = defaultIntl }) => (
  <Layout intl={intl} page="driver">
    <Banner intl={intl} />
    <WhyFant intl={intl} />
    <Team intl={intl} />
    <Requirement intl={intl} />
    <Faq intl={intl} />
    <Phone intl={intl} />
    <Actions intl={intl} />
  </Layout>
)

export default injectIntl(DriverPage)
